// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"162":"c1914501","453":"8cab0938"}[chunkId] + ".chunk.js";
};